/** View library */
import React from "react";
import Autobind from "autobind-decorator";
import { inject, observer } from "mobx-react";
import Form from "component/atoms/form";
import Button from "component/atoms/button";
import Image from "component/atoms/image";
import HorizontalSpliiter from "component/atoms/horizontalSplitter";
import { Route, Redirect } from "react-router-dom";
/** Resources */
import SVGUserLoginIcon from "assets/icon/SVGUserLoginIcon";
import SVGUserPasswordIcon from "assets/icon/SVGUserPasswordIcon";
import BrandImage_Login from "assets/brand/logo-login.png";
import "./loginForm.styl";

@inject("authStore")
@observer
@Autobind
class LoginForm extends React.Component {
  handleSubmit(e) {
    const {
      formBasicEmail,
      formBasicPassword,
      "custom-switch": customSwich,
    } = e.target.elements;
    const userID = formBasicEmail.value;
    const password = formBasicPassword.value;
    let connectApp = "sarcopenia-ai";
    // if (customSwich.checked === false) {
    //   connectApp = "sarcopenia-ai";
    // } else {
    //   connectApp = "webviewer";
    // }

    const { authStore } = this.props;
    authStore.setConnectApp(connectApp);
    const isLoginSuccess = authStore.requestSignIn(userID, password);

    let a = "";

    if (isLoginSuccess === true) {
      a = "success";
    } else {
      a = "fail";
    }
  }

  handleChange(e) {
    const { authStore } = this.props;
    let connectApp = "none";
    if (e.target.checked === false) {
      connectApp = "sarcopenia-ai";
    } else {
      connectApp = "webviewer";
    }

    authStore.setConnectApp(connectApp);
  }
  render() {
    const { authStore } = this.props;
    let connectApp = authStore.getConnectApp();
    let backgroundClassName = "";
    if (connectApp === "sarcopenia-ai") {
      backgroundClassName = "background-sarcopenia-ai";
    } else if (connectApp === "webviewer") {
      backgroundClassName = "background-webviewer";
    }

    return (
      <div className={"login-form align-center-xy " + backgroundClassName}>
        <div className="login-form__wrapper">
          <Form onSubmit={this.handleSubmit}>
            <div className="login-form__header ">
              <div className="pull-left">
                <Image src={BrandImage_Login}></Image>
              </div>
              <div className="pull-right">
                <label
                  title=""
                  // for="custom-switch"
                  class="custom-control-label"
                ></label>
                {/* <Form.Check
                  type="switch"
                  id="custom-switch"
                  label=" "
                  onChange={this.handleChange}
                /> */}
              </div>
            </div>
            <HorizontalSpliiter />

            <div className="login-form__content">
              <Form.Group controlId="formBasicEmail">
                <span className="vertical-middle">
                  <SVGUserLoginIcon />
                </span>

                <span>
                  <Form.Control type="email" placeholder="Enter email" />
                </span>
              </Form.Group>
              <Form.Group controlId="formBasicPassword">
                <div>
                  <span className="vertical-middle">
                    <SVGUserPasswordIcon />
                  </span>
                  <span>
                    <Form.Control type="password" placeholder="Password" />
                  </span>
                </div>
              </Form.Group>

              <Button visible={true} type={"primary"} size={"full"}>
                Login
              </Button>
              <hr className="login-form__content__H-splitter"></hr>
              <div className="login-form__notices">
                <span>
                  <p className="login-form__notices__title">
                    One Viewer for the enterprise{" "}
                  </p>
                  <p className="login-form__notices__content">
                    AID-U enables health care professionals to access,
                    manipulate and colaborate in real-time over full quality
                    medical images using any web-browser without installing
                    client software.
                  </p>
                </span>
              </div>
              {/* <div className="login-form__notices">
                <p className="login-form__notices">
                  <span>
                    <p className="login-form__notices__title">
                      One Viewer for the enterprise{" "}
                    </p>
                    <p className="login-form__notices__content">
                      AID-U enables health care professionals to access,
                      manipulate and colaborate in real-time over full quality
                      medical images using any web-browser without installing
                      client software.
                    </p>
                  </span>
                </p>
              </div> */}
            </div>
            <div className="login-form__footer text-center">
              <p>
                <span className="login-form__footer__contact">Contact - </span>
                <a className="email" href="mailto:cto@iaidimage.com">
                  contact@iAID.com
                </a>
              </p>
              <p>
                <span className="login-form__footer__contact">
                  Powered by iAID Inc. 2019
                </span>
              </p>
            </div>
          </Form>
        </div>
      </div>
    );
  }
}

export default LoginForm;
